/**
 * bomAggregateExport.ts
 *
 * Excel (.xlsx) export utility for the BOM Aggregate module.
 * Generates a workbook with 2 sheets: "BOM Gỗ" and "BOM Ngũ Kim".
 */
import * as XLSX from 'xlsx'
import type { FlatBomWoodRow, FlatBomHardwareRow } from './types'

export function generateBomAggregateWorkbook(
  woodRows: FlatBomWoodRow[],
  hardwareRows: FlatBomHardwareRow[],
): XLSX.WorkBook {
  const wb = XLSX.utils.book_new()

  // Sheet 1: BOM Gỗ
  const woodHeaders = [
    'STT',
    'Mã',
    'Màu',
    'Gỗ',
    'Kết cấu',
    'Tên Chi Tiết',
    'Loại Gỗ',
    'DÀY',
    'RỘNG',
    'DÀI',
    'Mộng',
    'SL',
    'Veneer',
    'Ghi chú',
  ]
  const woodData: (string | number)[][] = [woodHeaders]
  woodRows.forEach((r, idx) => {
    woodData.push([
      idx + 1,
      r.code,
      r.color,
      r.wood,
      r.assembly,
      r.part_name,
      r.wood_type_raw,
      r.dims_finished_t,
      r.dims_finished_w,
      r.dims_finished_l,
      r.tenon,
      r.qty_per,
      r.veneer_spec,
      r.notes,
    ])
  })
  const wsWood = XLSX.utils.aoa_to_sheet(woodData)
  wsWood['!cols'] = [
    { wch: 6 },  // STT
    { wch: 14 }, // Mã
    { wch: 14 }, // Màu
    { wch: 14 }, // Gỗ
    { wch: 14 }, // Kết cấu
    { wch: 24 }, // Tên Chi Tiết
    { wch: 16 }, // Loại Gỗ
    { wch: 10 }, // DÀY
    { wch: 10 }, // RỘNG
    { wch: 10 }, // DÀI
    { wch: 14 }, // Mộng
    { wch: 10 }, // SL
    { wch: 18 }, // Veneer
    { wch: 24 }, // Ghi chú
  ]
  XLSX.utils.book_append_sheet(wb, wsWood, 'BOM Gỗ')

  // Sheet 2: BOM Ngũ Kim
  const hwHeaders = [
    'STT',
    'Mã',
    'Màu',
    'Gỗ',
    'Kết cấu',
    'Tên Ngũ Kim',
    'Quy cách',
    'SL',
    'ĐVT',
    'Màu NK',
    'Loại',
    'Ghi chú',
  ]
  const hwData: (string | number)[][] = [hwHeaders]
  hardwareRows.forEach((r, idx) => {
    hwData.push([
      idx + 1,
      r.code,
      r.color,
      r.wood,
      r.assembly,
      r.name_raw,
      r.spec_raw,
      r.qty_per,
      r.uom_hint,
      r.color_hint,
      r.item_type,
      r.notes,
    ])
  })
  const wsHw = XLSX.utils.aoa_to_sheet(hwData)
  wsHw['!cols'] = [
    { wch: 6 },  // STT
    { wch: 14 }, // Mã
    { wch: 14 }, // Màu
    { wch: 14 }, // Gỗ
    { wch: 14 }, // Kết cấu
    { wch: 24 }, // Tên Ngũ Kim
    { wch: 18 }, // Quy cách
    { wch: 10 }, // SL
    { wch: 10 }, // ĐVT
    { wch: 12 }, // Màu NK
    { wch: 14 }, // Loại
    { wch: 24 }, // Ghi chú
  ]
  XLSX.utils.book_append_sheet(wb, wsHw, 'BOM Ngũ Kim')

  return wb
}

export function exportBomAggregateToExcel(
  woodRows: FlatBomWoodRow[],
  hardwareRows: FlatBomHardwareRow[],
  customFilename?: string,
): void {
  const wb = generateBomAggregateWorkbook(woodRows, hardwareRows)
  const today = new Date().toISOString().split('T')[0]
  const filename = customFilename || `tong-hop-dinh-muc_${today}.xlsx`
  XLSX.writeFile(wb, filename)
}
